export enum ExternalIntegrationProvider {
  SHOPIFY = 'shopify',
  ZAPIER = 'zapier',
  WOO_COMMERCE = 'woocommerce',
  SALESFORCE = 'salesforce',
  HUBSPOT = 'hubspot',
  ZOHO = 'zohocrm',
}
